module.exports = __webpack_public_path__ + "img/un_upload_b2b.7b4a6ffc.png";